import { render, staticRenderFns } from "./SecondToHumanTime.vue?vue&type=template&id=0c5948b3&scoped=true"
import script from "./SecondToHumanTime.vue?vue&type=script&lang=js"
export * from "./SecondToHumanTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5948b3",
  null
  
)

export default component.exports